export interface SearchBoxStateViewModel{
    isShow: boolean;
    isShowResult: boolean;
    isSearching: boolean;
    searchpayload: any;
}